import script from "./MarkAttendance.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkAttendance.vue?vue&type=script&setup=true&lang=js"

import "./MarkAttendance.vue?vue&type=style&index=0&id=0e0545ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e0545ae"]])

export default __exports__